import { Component } from '@angular/core';

@Component({
  selector: 'app-datapolicy',
  standalone: true,
  imports: [],
  templateUrl: './datapolicy.component.html',
  styleUrl: './datapolicy.component.scss'
})
export class DatapolicyComponent {

}
